/* eslint-disable  */
import React from 'react';

import './PopularCategories.scss';
import { Link } from 'gatsby';

import Container from '../Container/Container';
import { ABOUT_DATA } from './about';

const items = [
  {
    name: 'Рулонні матеріали (Єврорубероїд) та комплектуючі',
    image: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1780_2808)">
          <path
            d="M10.3998 32C9.29223 32 8.20953 32.3284 7.28861 32.9438C6.3677 33.5591 5.64993 34.4337 5.22608 35.457C4.80223 36.4802 4.69133 37.6062 4.90741 38.6925C5.12349 39.7788 5.65684 40.7766 6.44001 41.5598C7.22318 42.343 8.22101 42.8763 9.3073 43.0924C10.3936 43.3085 11.5196 43.1976 12.5428 42.7737C13.5661 42.3499 14.4407 41.6321 15.056 40.7112C15.6714 39.7903 15.9998 38.7076 15.9998 37.6C15.9981 36.1153 15.4075 34.6919 14.3577 33.6421C13.3079 32.5923 11.8845 32.0017 10.3998 32ZM10.3998 41.6C9.60868 41.6 8.83532 41.3654 8.17753 40.9259C7.51973 40.4864 7.00704 39.8616 6.70429 39.1307C6.40154 38.3998 6.32232 37.5956 6.47667 36.8196C6.63101 36.0437 7.01197 35.331 7.57138 34.7716C8.13079 34.2122 8.84352 33.8312 9.61944 33.6769C10.3954 33.5225 11.1996 33.6017 11.9305 33.9045C12.6614 34.2072 13.2862 34.7199 13.7257 35.3777C14.1652 36.0355 14.3998 36.8089 14.3998 37.6C14.3986 38.6605 13.9767 39.6772 13.2269 40.427C12.477 41.1769 11.4603 41.5987 10.3998 41.6Z"
            fill="#015BBB"
          />
          <path
            d="M10.4 27.2002C8.34308 27.2002 6.33235 27.8101 4.62207 28.9529C2.9118 30.0957 1.57881 31.7199 0.791658 33.6203C0.00450617 35.5206 -0.201449 37.6117 0.199838 39.6291C0.601124 41.6465 1.59163 43.4996 3.04609 44.9541C4.50056 46.4086 6.35366 47.3991 8.37107 47.8004C10.3885 48.2016 12.4796 47.9957 14.3799 47.2085C16.2803 46.4214 17.9045 45.0884 19.0473 43.3781C20.1901 41.6679 20.8 39.6571 20.8 37.6002C20.8 34.8419 19.7043 32.1967 17.7539 30.2463C15.8035 28.2959 13.1583 27.2002 10.4 27.2002ZM10.4 45.4002C8.85731 45.4002 7.34926 44.9427 6.06656 44.0857C4.78385 43.2286 3.78411 42.0104 3.19374 40.5851C2.60338 39.1599 2.44891 37.5915 2.74988 36.0785C3.05084 34.5654 3.79372 33.1756 4.88457 32.0848C5.97542 30.9939 7.36525 30.251 8.8783 29.9501C10.3914 29.6491 11.9597 29.8036 13.3849 30.3939C14.8102 30.9843 16.0284 31.984 16.8855 33.2667C17.7425 34.5494 18.2 36.0575 18.2 37.6002C18.1977 39.6682 17.3752 41.6508 15.9129 43.1131C14.4506 44.5754 12.468 45.3979 10.4 45.4002Z"
            fill="#015BBB"
          />
          <path
            d="M10.4 40.0002C11.7255 40.0002 12.8 38.9257 12.8 37.6002C12.8 36.2747 11.7255 35.2002 10.4 35.2002C9.07452 35.2002 8 36.2747 8 37.6002C8 38.9257 9.07452 40.0002 10.4 40.0002Z"
            fill="#015BBB"
          />
          <path
            d="M21.9073 14.4004V37.9204C21.9046 39.9529 21.359 41.9501 20.3236 43.7168C19.2883 45.4835 17.7986 46.9594 16 48.0004H49.6V14.4004H21.9073Z"
            fill="#FED501"
          />
          <path
            d="M10.4 26.0685C12.4971 26.0711 14.5576 26.619 16.3805 27.6586C18.2033 28.6982 19.726 30.1941 20.8 32V10.4274C20.8 7.66187 19.7043 5.00962 17.7539 3.05411C15.8035 1.0986 13.1583 0 10.4 0C7.64175 0 4.99647 1.0986 3.04609 3.05411C1.09571 5.00962 4.11012e-08 7.66187 0 10.4274V32C1.07399 30.1941 2.59674 28.6982 4.41955 27.6586C6.24236 26.619 8.30292 26.0711 10.4 26.0685Z"
            fill="#015BBB"
          />
        </g>
        <defs>
          <clipPath id="clip0_1780_2808">
            <rect width="48" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    link: '/ua/rulonni-materiali-yevroruberoyid-ta-komplektuyuchi',
  },
  {
    name: 'Пінополістирол, пінопласт (XPS, PPS)',
    image: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1780_2681)">
          <path
            d="M47.3394 14.3705L24.7457 0.214242C24.2898 -0.071414 23.7102 -0.071414 23.2543 0.214242L0.660563 14.3705C0.249937 14.6273 0 15.0777 0 15.5625C0 16.0473 0.249937 16.4978 0.660563 16.7545L23.2543 30.817C23.4823 30.9598 23.7418 31.0313 24 31.0313C24.2582 31.0313 24.5177 30.9598 24.7457 30.817L47.3394 16.7545C47.7501 16.4978 48 16.0473 48 15.5625C48 15.0777 47.7501 14.6273 47.3394 14.3705Z"
            fill="#015BBB"
          />
          <path
            d="M47.3394 31.2454L45.1499 29.877L24.7457 42.571C24.5177 42.7138 24.2582 42.7852 24 42.7852C23.7418 42.7852 23.4823 42.7138 23.2543 42.571L2.85009 29.877L0.660563 31.2454C0.249937 31.5022 0 31.9527 0 32.4375C0 32.9222 0.249937 33.3727 0.660563 33.6295L23.2543 47.7857C23.4823 47.9285 23.7418 48 24 48C24.2582 48 24.5177 47.9285 24.7457 47.7857L47.3394 33.6295C47.7501 33.3727 48 32.9222 48 32.4375C48 31.9527 47.7501 31.5022 47.3394 31.2454Z"
            fill="#015BBB"
          />
          <path
            d="M47.3394 22.8079L45.1499 21.4395L24.7457 34.1335C24.5177 34.2763 24.2582 34.3477 24 34.3477C23.7418 34.3477 23.4823 34.2763 23.2543 34.1335L2.85009 21.4395L0.660563 22.8079C0.249937 23.0647 0 23.5152 0 24C0 24.4847 0.249937 24.9352 0.660563 25.192L23.2543 39.2545C23.4823 39.3973 23.7418 39.4687 24 39.4687C24.2582 39.4687 24.5177 39.3973 24.7457 39.2545L47.3394 25.192C47.7501 24.9352 48 24.4847 48 24C48 23.5152 47.7501 23.0647 47.3394 22.8079Z"
            fill="#FED501"
          />
        </g>
        <defs>
          <clipPath id="clip0_1780_2681">
            <rect width="48" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    link: 'ua/pinopolistirol-pinoplast-xps-pps',
  },
  {
    name: 'Базальтовий та мінераловатний утеплювач',
    image: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1780_2723)">
          <path
            d="M47.1987 39.9142L47.8771 38.4047C48.0419 38.038 48.0419 37.6183 47.8771 37.2517L47.1987 35.7423L47.8771 34.2328C48.0726 33.7976 48.0343 33.2931 47.7752 32.8925C47.5159 32.492 47.0715 32.25 46.5944 32.25H40.0366C38.1326 36.9941 34.6378 40.9336 30.2158 43.4063H46.5945C47.0716 43.4063 47.516 43.1645 47.7753 42.7639C48.0344 42.3634 48.0727 41.8587 47.8772 41.4235L47.1987 39.9142Z"
            fill="#FED501"
          />
          <path
            d="M20.3001 29.5534C23.3663 29.0563 25.449 26.1677 24.952 23.1015C24.4549 20.0353 21.5663 17.9526 18.5001 18.4496C15.4339 18.9467 13.3512 21.8353 13.8482 24.9015C14.3453 27.9677 17.2339 30.0504 20.3001 29.5534Z"
            fill="#FED501"
          />
          <path
            d="M38.8125 24C38.8125 13.2994 30.1069 4.59375 19.4062 4.59375C8.70563 4.59375 0 13.2994 0 24C0 34.7006 8.70563 43.4062 19.4062 43.4062C30.1069 43.4062 38.8125 34.7006 38.8125 24ZM19.4062 32.4375C14.7538 32.4375 10.9688 28.6524 10.9688 24C10.9688 19.3476 14.7538 15.5625 19.4062 15.5625C24.0587 15.5625 27.8438 19.3476 27.8438 24C27.8438 28.6524 24.0587 32.4375 19.4062 32.4375Z"
            fill="#015BBB"
          />
        </g>
        <defs>
          <clipPath id="clip0_1780_2723">
            <rect width="48" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    link: '/ua/bazaltovij-ta-mineralovatnij-uteplyuvach',
  },
  {
    name: 'Сухі будівельні суміші та клеї',
    image: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M41.6229 9.95461C42.1744 19.3181 42.1744 28.6815 41.6229 38.0451C41.5663 39.0069 41.9392 39.939 42.6272 40.6133C43.4581 41.4278 43.9605 42.5759 43.9172 43.841C43.8392 46.1182 41.9561 47.9639 39.6779 47.9988C38.5133 48.0167 37.4528 47.5723 36.6675 46.8373C35.9775 46.1917 35.0551 45.8569 34.1131 45.9329C27.371 46.4762 20.6289 46.4762 13.8868 45.9329C12.9448 45.8569 12.0224 46.1916 11.3324 46.8373C10.547 47.5723 9.48661 48.0167 8.32195 47.9988C6.04373 47.9639 4.16067 46.1182 4.08267 43.841C4.03936 42.5759 4.54176 41.4278 5.37258 40.6133C6.06051 39.9389 6.43345 39.0067 6.37683 38.0449C5.8253 28.6815 5.8253 19.318 6.37683 9.95442C6.43355 8.99264 6.06061 8.06048 5.37258 7.38605C4.54176 6.57155 4.03936 5.42348 4.08267 4.15833C4.16058 1.88114 6.04373 0.0354848 8.32195 0.000516099C9.48661 -0.0172964 10.547 0.427079 11.3324 1.16198C12.0224 1.80773 12.9448 2.14252 13.8868 2.06658C20.6289 1.5232 27.3709 1.5232 34.1131 2.06658C35.0551 2.14252 35.9775 1.80783 36.6675 1.16208C37.4528 0.427078 38.5133 -0.0172964 39.678 0.000609849C41.9562 0.0356723 43.8392 1.88133 43.9172 4.15852C43.9605 5.42358 43.4581 6.57164 42.6272 7.38614C41.9392 8.06067 41.5663 8.99283 41.6229 9.95461ZM14.3366 15.0746C20.7781 14.6694 27.2197 14.6694 33.6613 15.0746C35.1403 15.1676 36.3291 16.3166 36.4889 17.7899C36.9383 21.9299 36.9383 26.07 36.4889 30.2101C36.329 31.6834 35.1403 32.8324 33.6613 32.9254C27.2197 33.3306 20.7781 33.3306 14.3366 32.9254C12.8576 32.8323 11.6687 31.6834 11.5089 30.2101C11.0595 26.07 11.0595 21.9299 11.5089 17.7899C11.6688 16.3166 12.8576 15.1676 14.3366 15.0746Z"
          fill="#015BBB"
        />
        <path
          d="M33.3002 21.4418H14.6979C14.2978 21.4418 13.9736 21.1175 13.9736 20.7175C13.9736 20.3174 14.2979 19.9932 14.6979 19.9932H33.3003C33.7004 19.9932 34.0246 20.3174 34.0246 20.7175C34.0246 21.1175 33.7003 21.4418 33.3002 21.4418Z"
          fill="#FED501"
        />
        <path
          d="M33.3002 24.725H14.6979C14.2978 24.725 13.9736 24.4007 13.9736 24.0007C13.9736 23.6006 14.2979 23.2764 14.6979 23.2764H33.3003C33.7004 23.2764 34.0246 23.6006 34.0246 24.0007C34.0246 24.4007 33.7003 24.725 33.3002 24.725Z"
          fill="#FED501"
        />
        <path
          d="M30.9896 28.0072H17.0075C16.6074 28.0072 16.2832 27.6829 16.2832 27.2829C16.2832 26.8829 16.6075 26.5586 17.0075 26.5586H30.9897C31.3898 26.5586 31.714 26.8829 31.714 27.2829C31.714 27.6829 31.3897 28.0072 30.9896 28.0072Z"
          fill="#FED501"
        />
      </svg>
    ),
    link: '/ua/sukhi-budivelni-sumishi-ta-kleyi',
  },
  {
    name: 'Гіпсокартонні системи',
    image: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1783_1068)">
          <path
            d="M32.0005 3.68967C32.0005 2.21887 30.8061 1.01953 29.337 1.01953H2.6652C1.19276 1.01953 0 2.21887 0 3.68967V31.8865C0 33.3606 1.19276 34.5567 2.6652 34.5567H12.125V13.0442C12.125 11.5718 13.3178 10.3741 14.7902 10.3741H32.0022L32.0005 3.68967Z"
            fill="#FED501"
          />
          <path
            d="M45.337 13.4453H18.6668C17.1928 13.4453 16 14.6414 16 16.1089V44.309C16 45.7831 17.1928 46.9792 18.6668 46.9792H45.337C46.8061 46.9792 48.0005 45.7831 48.0005 44.309V16.1089C48.0005 14.6397 46.8045 13.4453 45.337 13.4453Z"
            fill="#015BBB"
          />
        </g>
        <defs>
          <clipPath id="clip0_1783_1068">
            <rect width="48" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    link: '/ua/gipsokartonni-sistemi',
  },
  {
    name: 'Будівельні піни',
    image: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.75 35.0325L2.25 30.3075V36H15.75V35.0325ZM2.25 28.7175L15.75 33.4425V30.5325L2.25 25.8075V28.7175ZM15.75 28.9425V22.5H2.25V24.2175L15.75 28.9425ZM8.25 7.5H9.75V4.5H8.25V7.5ZM30.75 6V4.5H11.25V6H30.75ZM10.14 9H7.86L6.06 11.25H11.94L10.14 9ZM14.25 12.75H3.75C3.35218 12.75 2.97065 12.908 2.68934 13.1893C2.40804 13.4706 2.25 13.8522 2.25 14.25V21H15.75V14.25C15.75 13.8522 15.592 13.4706 15.3107 13.1893C15.0294 12.908 14.6478 12.75 14.25 12.75ZM3.75 45.75H14.25C14.6478 45.75 15.0294 45.592 15.3107 45.3107C15.592 45.0294 15.75 44.6478 15.75 44.25V37.5H2.25V44.25C2.25 44.6478 2.40804 45.0294 2.68934 45.3107C2.97065 45.592 3.35218 45.75 3.75 45.75Z"
          fill="#015BBB"
        />
        <path
          d="M32.7762 25.6882C32.3754 26.0391 32.0543 26.4715 31.8342 26.9566C31.6142 27.4416 31.5004 27.9681 31.5004 28.5007C31.5004 29.0334 31.6142 29.5599 31.8342 30.0449C32.0543 30.53 32.3754 30.9624 32.7762 31.3132C32.856 31.3836 32.9199 31.4702 32.9637 31.5672C33.0074 31.6642 33.0301 31.7693 33.0301 31.8757C33.0301 31.9822 33.0074 32.0873 32.9637 32.1843C32.9199 32.2813 32.856 32.3679 32.7762 32.4382C32.3762 32.7896 32.0557 33.222 31.8359 33.7068C31.616 34.1916 31.5019 34.7177 31.5012 35.25C31.4974 36.0912 31.7813 36.9084 32.3059 37.566C32.3783 37.657 32.4285 37.7636 32.4526 37.8774C32.4766 37.9912 32.4739 38.109 32.4447 38.2215C32.2302 39.0456 32.1935 39.9059 32.3372 40.7452C32.4809 41.5845 32.8016 42.3837 33.2779 43.0895C33.7543 43.7953 34.3755 44.3916 35.1001 44.8388C35.8248 45.2861 36.6363 45.5739 37.4808 45.6832C38.3253 45.7925 39.1834 45.7209 39.9981 45.4729C40.8127 45.225 41.5653 44.8065 42.2057 44.2453C42.8461 43.6841 43.3597 42.9929 43.7124 42.2179C44.0651 41.4428 44.2487 40.6015 44.2512 39.75C44.2512 39.63 44.2444 39.5167 44.2377 39.4035C44.2313 39.2898 44.2507 39.1762 44.2945 39.0712C44.3383 38.9661 44.4052 38.8723 44.4904 38.7967C45.1842 38.1831 45.6253 37.3337 45.7281 36.4132C45.831 35.4927 45.5882 34.5668 45.0469 33.8152C44.9541 33.6872 44.9041 33.5331 44.9041 33.375C44.9041 33.2169 44.9541 33.0628 45.0469 32.9347C45.5456 32.2427 45.7922 31.4008 45.7455 30.5491C45.6988 29.6974 45.3617 28.8874 44.7904 28.254C44.6652 28.116 44.5958 27.9363 44.5958 27.75C44.5958 27.5637 44.6652 27.384 44.7904 27.246C45.4099 26.5624 45.7524 25.6725 45.7512 24.75C45.7504 24.2177 45.6363 23.6916 45.4164 23.2068C45.1966 22.722 44.8761 22.2896 44.4762 21.9382C44.3964 21.8679 44.3324 21.7813 44.2887 21.6843C44.2449 21.5873 44.2222 21.4822 44.2222 21.3757C44.2222 21.2693 44.2449 21.1642 44.2887 21.0672C44.3324 20.9702 44.3964 20.8836 44.4762 20.8132C44.8769 20.4624 45.1981 20.03 45.4181 19.5449C45.6381 19.0599 45.752 18.5334 45.752 18.0007C45.752 17.4681 45.6381 16.9416 45.4181 16.4566C45.1981 15.9715 44.8769 15.5391 44.4762 15.1882C44.3964 15.1179 44.3324 15.0313 44.2887 14.9343C44.2449 14.8373 44.2222 14.7322 44.2222 14.6257C44.2222 14.5193 44.2449 14.4142 44.2887 14.3172C44.3324 14.2202 44.3964 14.1336 44.4762 14.0632C45.0247 13.5817 45.4206 12.9503 45.6152 12.2468C45.8098 11.5433 45.7947 10.7982 45.5716 10.1032C45.3485 9.40814 44.9272 8.79343 44.3596 8.33456C43.7919 7.87569 43.1025 7.59266 42.3762 7.52025C42.2429 7.5069 42.1157 7.45813 42.0077 7.379C41.8997 7.29987 41.8148 7.19326 41.7619 7.07025C41.5276 6.52916 41.1401 6.06848 40.6471 5.74503C40.1542 5.42157 39.5773 5.24949 38.9877 5.25C38.8571 5.27141 38.7233 5.25793 38.5997 5.21092C38.476 5.1639 38.367 5.08503 38.2837 4.9823C38.2004 4.87957 38.1457 4.75664 38.1253 4.62597C38.1048 4.4953 38.1193 4.36153 38.1672 4.23825C38.2251 4.0821 38.2536 3.91655 38.2512 3.75C38.2512 3.35218 38.0931 2.97064 37.8118 2.68934C37.5305 2.40804 37.149 2.25 36.7512 2.25C36.3533 2.25 35.9718 2.40804 35.6905 2.68934C35.4092 2.97064 35.2512 3.35218 35.2512 3.75C35.2482 4.0692 35.349 4.38071 35.5384 4.63769C35.7278 4.89468 35.9954 5.08323 36.3012 5.175C36.4188 5.21033 36.526 5.27403 36.6133 5.36049C36.7006 5.44694 36.7653 5.55352 36.8017 5.67084C36.8381 5.78816 36.8452 5.91264 36.8223 6.03333C36.7993 6.15402 36.7471 6.26722 36.6702 6.363C36.2365 6.89617 36.0002 7.56272 36.0012 8.25C35.9975 8.70322 36.1003 9.15096 36.3012 9.55725C36.3512 9.65741 36.3782 9.76752 36.3802 9.87948C36.3821 9.99144 36.359 10.1024 36.3125 10.2043C36.2659 10.3061 36.1972 10.3963 36.1112 10.4681C36.0253 10.5399 35.9244 10.5915 35.8159 10.6192C35.0099 10.8255 34.2956 11.2944 33.7859 11.9519C33.2762 12.6094 33 13.418 33.0012 14.25C32.998 14.7637 33.1025 15.2724 33.3077 15.7433C33.513 16.2143 33.8145 16.6371 34.1929 16.9845C34.287 17.0716 34.3573 17.1815 34.3968 17.3035C34.4364 17.4255 34.4441 17.5556 34.419 17.6814C34.3939 17.8072 34.337 17.9245 34.2537 18.022C34.1704 18.1195 34.0635 18.1941 33.9432 18.2385C33.3353 18.4637 32.7964 18.843 32.3792 19.3391C31.962 19.8352 31.6809 20.4311 31.5632 21.0686C31.4456 21.706 31.4955 22.3631 31.7081 22.9754C31.9208 23.5878 32.2888 24.1344 32.7762 24.5617C32.856 24.6321 32.9199 24.7187 32.9637 24.8157C33.0074 24.9127 33.0301 25.0178 33.0301 25.1242C33.0301 25.2307 33.0074 25.3358 32.9637 25.4328C32.9199 25.5298 32.856 25.6164 32.7762 25.6867V25.6882Z"
          fill="#FED501"
        />
      </svg>
    ),
    link: '/ua/budivelni-pini',
  },
  {
    name: 'Бітумні мастики та праймери',
    image: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M24.0486 0C24.0486 0.0110396 24.0375 0.0110396 24.0154 0.0110396C15.239 0.0110396 8.10742 7.15363 8.10742 15.9411V22.4545H8.14054L10.3153 18.7452V15.9301C10.3153 8.36799 16.4533 2.20791 24.0154 2.20791C31.5665 2.20791 37.6935 8.33487 37.6935 15.8859C37.6935 15.897 37.6935 15.908 37.6935 15.9301V18.7452L39.8572 22.4545H39.8903V15.9301C39.9124 7.15363 32.825 0.0220791 24.0486 0Z"
          fill="#015BBB"
        />
        <path
          d="M34.4937 25.5122C31.7559 26.2298 28.0466 26.6272 24.0282 26.6272C24.0172 26.6272 24.0061 26.6272 24.0061 26.6272V36.0439C24.0061 36.6511 23.5094 37.1479 22.9022 37.1479C22.295 37.1479 21.7982 36.6511 21.7982 36.0439V26.583C20.9151 26.5499 20.1423 26.5058 19.3695 26.4395V31.4515C19.3695 32.0587 18.8727 32.5554 18.2656 32.5554C17.6584 32.5554 17.1616 32.0587 17.1616 31.4515V26.285C17.1616 26.2629 17.1395 26.2298 17.1395 26.2077C16.3005 26.0973 15.5057 25.9648 14.7329 25.8103V37.1921C14.7329 37.7992 14.2361 38.296 13.629 38.296C13.0218 38.296 12.525 37.7992 12.525 37.1921V25.2362C11.7522 24.9602 10.9353 24.6511 10.3281 24.3089L10.3723 44.8977C10.4054 45.3061 11.1892 46.1672 13.9491 46.9179C16.5213 47.6134 20.0981 47.9998 24.0061 47.9998C27.9141 47.9998 31.491 47.6134 34.0632 46.9179C36.8231 46.1672 37.6069 45.3061 37.64 44.8977L37.6621 24.2979C36.8341 24.7726 35.7853 25.17 34.4937 25.5122Z"
          fill="#015BBB"
        />
        <path
          d="M24.0059 18.1494C14.4898 18.1494 10.3721 20.2249 10.3721 21.2846C10.3721 21.3067 10.3721 21.3178 10.3721 21.3288C10.3721 21.3288 10.3721 21.3398 10.3721 21.3509C10.5266 22.4217 14.6775 24.4088 24.0059 24.4088C33.3344 24.4088 37.4852 22.4107 37.6398 21.3398C37.6398 21.3398 37.6398 21.3288 37.6398 21.3178C37.6398 21.3067 37.6398 21.2957 37.6398 21.2846C37.6398 20.2359 33.522 18.1494 24.0059 18.1494Z"
          fill="#FED501"
        />
      </svg>
    ),
    link: '/ua/bitumni-mastiki-ta-prajmeri',
  },
  {
    name: 'Бітумна черепиця та комплектуючі',
    image: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1780_2752)">
          <path
            d="M5.01562 19.7812C7.73401 19.7812 9.9375 17.5778 9.9375 14.8594V8.4375H0V14.8594C0 17.5778 2.29724 19.7812 5.01562 19.7812Z"
            fill="#015BBB"
          />
          <path
            d="M22.5938 14.8594V8.4375H12.75V14.8594C12.75 17.5778 14.9535 19.7812 17.6719 19.7812C20.3903 19.7812 22.5938 17.5778 22.5938 14.8594Z"
            fill="#015BBB"
          />
          <path
            d="M35.25 8.4375H25.4062V14.8594C25.4062 17.5778 27.6097 19.7812 30.3281 19.7812C33.0465 19.7812 35.25 17.5778 35.25 14.8594V8.4375Z"
            fill="#FED501"
          />
          <path
            d="M48 8.4375H38.0625V14.8594C38.0625 17.5778 40.266 19.7812 42.9844 19.7812C45.7028 19.7812 48 17.5778 48 14.8594V8.4375Z"
            fill="#015BBB"
          />
          <path
            d="M48 20.7754C46.6586 21.8931 44.8634 22.5933 42.9844 22.5933C41.1053 22.5933 39.4039 21.8931 38.0625 20.7754V28.9214C38.0625 31.6398 40.266 33.8433 42.9844 33.8433C45.7028 33.8433 48 31.6398 48 28.9214V20.7754Z"
            fill="#015BBB"
          />
          <path
            d="M35.25 20.7754C33.9086 21.8931 32.2072 22.5933 30.3281 22.5933C28.4491 22.5933 26.7477 21.8931 25.4062 20.7754V28.9214C25.4062 31.6398 27.6097 33.8433 30.3281 33.8433C33.0465 33.8433 35.25 31.6398 35.25 28.9214V20.7754Z"
            fill="#015BBB"
          />
          <path
            d="M12.75 28.9214C12.75 31.6398 14.9535 33.8433 17.6719 33.8433C20.3903 33.8433 22.5938 31.6398 22.5938 28.9214V20.7754C21.2523 21.8931 19.5509 22.5933 17.6719 22.5933C15.7928 22.5933 14.0914 21.8931 12.75 20.7754V28.9214Z"
            fill="#015BBB"
          />
          <path
            d="M5.01562 33.8433C7.73401 33.8433 9.9375 31.6398 9.9375 28.9214V20.7754C8.59607 21.8931 6.89465 22.5933 5.01562 22.5933C3.1366 22.5933 1.34143 21.8931 0 20.7754V28.9214C0 31.6398 2.29724 33.8433 5.01562 33.8433Z"
            fill="#FED501"
          />
          <path
            d="M38.0625 34.8379V43.0776C38.0625 45.796 40.266 47.9995 42.9844 47.9995C45.7028 47.9995 48 45.796 48 43.0776V34.8379C46.6586 35.9556 44.8634 36.6558 42.9844 36.6558C41.1053 36.6558 39.4039 35.9556 38.0625 34.8379Z"
            fill="#FED501"
          />
          <path
            d="M25.4062 34.8379V43.0776C25.4062 45.796 27.6097 47.9995 30.3281 47.9995C33.0465 47.9995 35.25 45.796 35.25 43.0776V34.8379C33.9086 35.9556 32.2072 36.6558 30.3281 36.6558C28.4491 36.6558 26.7477 35.9556 25.4062 34.8379Z"
            fill="#015BBB"
          />
          <path
            d="M12.75 43.0776C12.75 45.796 14.9535 47.9995 17.6719 47.9995C20.3903 47.9995 22.5938 45.796 22.5938 43.0776V34.8379C21.2523 35.9556 19.5509 36.6558 17.6719 36.6558C15.7928 36.6558 14.0914 35.9556 12.75 34.8379V43.0776Z"
            fill="#FED501"
          />
          <path
            d="M5.01562 47.9995C7.73401 47.9995 9.9375 45.796 9.9375 43.0776V34.8379C8.59607 35.9556 6.89465 36.6558 5.01562 36.6558C3.1366 36.6558 1.34143 35.9556 0 34.8379V43.0776C0 45.796 2.29724 47.9995 5.01562 47.9995Z"
            fill="#015BBB"
          />
          <path d="M0 0H48V5.625H0V0Z" fill="#015BBB" />
        </g>
        <defs>
          <clipPath id="clip0_1780_2752">
            <rect width="48" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    link: '/ua/bitumna-cherepiczya-ta-komplektuyuchi',
  },
  {
    name: 'Мембрани ПВХ та комплектуючі',
    image: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1783_1039)">
          <path
            d="M40.1396 2.15766C37.2988 0.8895 34.2486 0.158625 31.1436 0C33.3461 0.794344 34.4614 1.83047 34.4614 3.08878V42.8563C36.0285 43.1473 37.5666 43.5857 39.0544 44.1683C39.9836 44.5321 40.9867 43.8391 40.9867 42.8411V3.45919C40.9868 2.89603 40.6538 2.38725 40.1396 2.15766Z"
            fill="#FED501"
          />
          <path
            d="M29.8904 6.57228C27.3118 7.28037 23.8999 7.67028 20.2832 7.67028C16.6665 7.67028 13.2548 7.28037 10.6762 6.57228C9.59225 6.27462 8.70022 5.93347 8 5.55078V45.3149C8 45.4701 8.56559 46.2522 11.1783 46.9697C13.5979 47.6341 16.8314 48 20.2832 48C23.735 48 26.9685 47.6341 29.3882 46.9697C32.0009 46.2522 32.5665 45.4701 32.5665 45.3149V5.55078C31.8663 5.93347 30.9744 6.27462 29.8904 6.57228Z"
            fill="#015BBB"
          />
          <path
            d="M29.3882 1.43363C26.9686 0.769227 23.735 0.40332 20.2832 0.40332C16.8314 0.40332 13.5979 0.769227 11.1783 1.43363C8.56559 2.1511 8 2.93335 8 3.08851C8 3.24366 8.56559 4.02591 11.1783 4.74338C13.5979 5.40779 16.8313 5.77369 20.2832 5.77369C23.7351 5.77369 26.9686 5.40779 29.3882 4.74338C32.0009 4.02591 32.5665 3.24366 32.5665 3.08851C32.5665 2.93335 32.0009 2.1511 29.3882 1.43363ZM23.498 3.13669C23.4721 3.64323 23.0533 4.03651 22.5519 4.0366C22.5356 4.0366 22.5192 4.03623 22.5028 4.03529C21.0538 3.96151 19.5129 3.96151 18.0637 4.03529C17.5427 4.06313 17.0952 3.65973 17.0685 3.13669C17.0419 2.61376 17.4443 2.16816 17.9672 2.14154C19.4803 2.06429 21.0865 2.06438 22.5993 2.14154C23.1223 2.16816 23.5246 2.61376 23.498 3.13669Z"
            fill="#015BBB"
          />
        </g>
        <defs>
          <clipPath id="clip0_1783_1039">
            <rect width="48" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    link: '/ua/membrani-pvkh-ta-komplektuyuchi',
  },
  {
    name: 'Металопрокат',
    image: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1780_2707)">
          <path
            d="M36.9997 12.4894H46.6281L24.7337 0.203391C24.2456 -0.070574 24.7219 0.0115312 14.7139 0.0115312L36.9997 12.4894Z"
            fill="#015BBB"
          />
          <path d="M37.2569 25.744H46.8852L18.4273 9.8324C17.9447 9.56256 18.4357 9.64167 8.39551 9.64167L37.2569 25.744Z" fill="#FED501" />
          <path
            d="M30.6982 35.3737H40.3217L11.8639 19.4622C11.3884 19.1964 11.8747 19.2715 2.24023 19.2715L30.6982 35.3737Z"
            fill="#015BBB"
          />
          <path
            d="M28.8047 37.7472L0.00585938 21.4521V30.3982C0.00585938 30.9413 0.299507 31.442 0.773675 31.7071L28.8048 47.38C28.8047 46.2555 28.8047 39.4475 28.8047 37.7472Z"
            fill="#015BBB"
          />
          <path d="M31.8047 38.3721V47.9997H39.9326C40.7609 47.9997 41.4323 47.3282 41.4323 46.5V38.3721H31.8047Z" fill="#015BBB" />
          <path
            d="M17.696 6.64189C18.463 6.64189 19.2221 6.83975 19.8915 7.214L35.1092 15.7226V14.868L12.873 2.41797V6.64189H17.696Z"
            fill="#015BBB"
          />
          <path d="M47.735 22.7822V15.4883H38.1074V17.3993L47.735 22.7822Z" fill="#015BBB" />
          <path
            d="M11.133 16.272C11.9 16.272 12.6591 16.4699 13.3285 16.8441L35.3673 29.1666V28.1241L6.56836 12.0566V16.272H11.133Z"
            fill="#FED501"
          />
          <path
            d="M38.3672 28.7422V30.8427L41.7868 32.7548C42.513 33.1608 43.0162 33.8344 43.2205 34.5977C43.7962 36.7481 44.4304 37.1798 44.4313 38.3699H46.495C47.3233 38.3699 47.9947 37.6985 47.9947 36.8702V28.7423H38.3672V28.7422Z"
            fill="#FED501"
          />
        </g>
        <defs>
          <clipPath id="clip0_1780_2707">
            <rect width="48" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    link: '/ua/metaloprokat',
  },
  {
    name: 'Кріплення',
    image: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.6 3.2002H4L5.75984 8.0001H7.52021V11.2002H18.0803V8.0001H19.8402L21.6 3.2002Z" fill="#015BBB" />
        <path
          d="M41.5998 17.0062V14.4004H28.7998V17.0062H30.3996V19.6119H28.7998V22.2175H30.3996V24.8233H28.7998V27.429H30.3996V30.0348H28.7998V32.6406H30.3996V35.2462H28.7998V37.8519H30.3996V39.5889L35.1998 44.8004L40 39.5889V37.8519H41.5998V35.2462H40V32.6406H41.5998V30.0348H40V27.429H41.5998V24.8233H40V22.2175H41.5998V19.6119H40V17.0062H41.5998Z"
          fill="#FED501"
        />
        <path
          d="M19.2004 17.0062V14.4004H6.40039V17.0062H8.00069V19.6119H6.40039V22.2175H8.00069V24.8233H6.40039V27.429H8.00069V30.0348H6.40039V32.6406H8.00069V35.2462H6.40039V37.8519H8.00069V39.5889L12.8006 44.8004L17.6006 39.5889V37.8519H19.2004V35.2462H17.6006V32.6406H19.2004V30.0348H17.6006V27.429H19.2004V24.8233H17.6006V22.2175H19.2004V19.6119H17.6006V17.0062H19.2004Z"
          fill="#015BBB"
        />
        <path
          d="M43.6 6.40029C43.6 4.64064 42.015 3.2002 40.0798 3.2002H29.5202C27.585 3.2002 26 4.64064 26 6.40029V8.0001H29.5202V11.2002H40.0798V8.0001H43.6V6.40029Z"
          fill="#FED501"
        />
      </svg>
    ),
    link: '/ua/kriplennya',
  },
  {
    name: 'Водовідвідні системи',
    image: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1780_2840)">
          <path
            d="M15.5313 6.70703H43.7649C45.0587 6.70703 45.6709 8.30247 44.7093 9.16801L30.5925 21.8731C30.3333 22.1064 29.9968 22.2355 29.6481 22.2355H1.41452C0.120748 22.2355 -0.491497 20.6401 0.470134 19.7745L14.587 7.06935C14.8462 6.83602 15.1826 6.70703 15.5313 6.70703ZM30.2724 12.0103L27.1353 14.8337C26.5558 15.3552 26.5088 16.2478 27.0304 16.8273C27.552 17.4068 28.4445 17.4538 29.0241 16.9322L32.1611 14.1088C32.7407 13.5873 32.7876 12.6947 32.266 12.1152C31.7444 11.5357 30.8519 11.4887 30.2724 12.0103ZM22.5081 12.0103L19.371 14.8337C18.7915 15.3552 18.7445 16.2478 19.2661 16.8273C19.7877 17.4068 20.6802 17.4538 21.2598 16.9322L24.3968 14.1088C24.9764 13.5873 25.0233 12.6947 24.5017 12.1152C23.9802 11.5357 23.0876 11.4887 22.5081 12.0103ZM14.7439 12.0103L11.6068 14.8337C11.0273 15.3552 10.9803 16.2478 11.5019 16.8273C12.0235 17.4068 12.916 17.4538 13.4956 16.9322L16.6326 14.1088C17.2122 13.5873 17.2591 12.6947 16.7375 12.1152C16.2159 11.5357 15.3234 11.4887 14.7439 12.0103Z"
            fill="#015BBB"
          />
          <path
            d="M22.5897 26H15.5312V33.7643C15.5312 38.4423 19.3234 42.2344 24.0013 42.2344H46.5882C47.3679 42.2344 47.9999 41.6024 47.9999 40.8227V36.5877C47.9999 35.808 47.3679 35.176 46.5882 35.176H24.0013C23.2217 35.176 22.5897 34.544 22.5897 33.7643V26Z"
            fill="#FED501"
          />
        </g>
        <defs>
          <clipPath id="clip0_1780_2840">
            <rect width="48" height="48" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    link: '/ua/vodovidvidni-sistemi',
  },
];

const PopularCategories: React.FC = () => {
  return (
    <div className="popularCategories">
      <Container>
        <h2 className="popularCategories__title">Популярні категорії</h2>
        <ul className="popularCategories__list">
          {items.map(item => (
            <li key={item.name} className="item">
              <Link to={item.link}>
                <div className="item__image">{item.image}</div>
                <p className="item__text">{item.name}</p>
              </Link>
            </li>
          ))}
        </ul>
        <ul className="popularCategories__about">
          {ABOUT_DATA.map(item => (
            <li key={item.title} className="item">
              <img className="item__image" src={item.icon} />
              <p className="item__title">{item.title}</p>
              <p className="item__text">{item.text}</p>
            </li>
          ))}
        </ul>
      </Container>
      <div className="blue-circle" />
      <div className="yellow-circle" />
    </div>
  );
};

export default PopularCategories;
